let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kWcF6")).then(() => parcelRequire('lv9za'));